import React from "react";
import {Button, ButtonGroup} from "reactstrap";
import UserIcon from "../media/images/UserIcon.mjs";
import appLib from "../libs/appLib.mjs";
import LockOffIcon from "../media/images/LockOffIcon.mjs";
import TextLabel from "../controls/TextLabel.mjs";
import "./FormTitle.css";
import G from "../libs/Glob.mjs";

class FormTitle extends React.Component {
	constructor(opts) {
		super(opts);
		this.state = {
			admin: G.userIsAdmin(),
			user: G.getUserLoginName(),
			group: appLib.group(),
			pageTitle: G.getStatus('pageTitle') || ''
		};
		this.uid = G.generateUid();
		this.restartForm = this.restartForm.bind(this);
		this.saveForm = this.saveForm.bind(this);
		this.renderLogin = this.renderLogin.bind(this);
	}
	componentDidMount() {
		G.register('pageTitle', (x)=>{
			this.setState({ pageTitle: x || '' }, ()=>{
				window.document.title = window.document.title.replace(/ :: .+$/,'') + (x ? ' :: '+ x : '');
			});
		}, this.uid);
		G.register('pageButtons', b => {
			this.setState({buttons: b })
		}, this.uid);
		G.register('itemFormValid', (v) => {
			this.setState({formIsValid: !!v })
		} , this.uid);
		G.register('userLogin', () => {
			this.setState({user: G.getUserLoginName(), admin: G.userIsAdmin() });
		} , this.uid);
		G.register('userActiveGroup', (v) => { this.setState({group: v })}, this.uid);
	}
	componentWillUnmount() {
		G.deregister(this.uid);
	}
	restartForm() {
		if ( window.confirm("ATTENZIONE\n\nAnnullare significa perdere tutti i cambiamenti non salvati.\n\nProcedere?"))
			G.setStatus('currentItem',false);
	}
	saveForm(){
		G.trigger('saveItemFormData' );
	}
	renderLogin() {
		if ( ! this.state.user ) return '';
		return(
			<ButtonGroup className={"btn-icon"}>
				<Button color={"primary"} disabled={true}>
					<i><UserIcon /></i>
					<b>{ this.state.user }</b>
				</Button>
				<Button color={"warning"} onClick={ G.logout }>
					<b><TextLabel value={"Logout"} /></b>
					<i><LockOffIcon/></i>
				</Button>
			</ButtonGroup>
		);
	}
	render() {
			return(
				<div className={"FormTitle"}>
					<h4>
						{ this.state.pageTitle }
					</h4>
					{ this.state.buttons || this.renderLogin() }
				</div>
			);
		}
}

export default FormTitle;